import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=17627630&lang=pug&"
import script from "./AdminEdit.vue?vue&type=script&lang=js&"
export * from "./AdminEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports